import { render, staticRenderFns } from "./NoticeEdit.vue?vue&type=template&id=b1ac0414&"
import script from "./NoticeEdit.vue?vue&type=script&lang=js&"
export * from "./NoticeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports